import { Grid, makeStyles, Typography } from "@material-ui/core";
import { Icon } from "../base/Icon";
import { ModalBox } from "../boxes/ModalBox";
import RemoveIcon from "../../assets/images/icons/remove.svg";
import { ButtonsGroup } from "../buttonsGroup";
import { CheckboxesGroup } from "../buttonsGroup/CheckboxesGroup";
import { useState } from "react";

const APPS = ["App 1", "App 2", "App 3"];

const useStyles = makeStyles((theme) => ({
  selectApp: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
}));

export const IntegrateAppModal = ({ onClose }) => {
  const classes = useStyles();
  const [checkedValues, setCheckedValues] = useState({});

  return (
    <ModalBox width={800}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Typography variant="h2">
          Integrate With Carbon Management Apps
        </Typography>
        <Icon src={RemoveIcon} hoverable onClick={onClose} />
      </Grid>
      <Typography variant="subtitle1" className={classes.selectApp}>
        Select app/s:
      </Typography>
      <CheckboxesGroup
        options={APPS}
        checkedValues={{}}
        onChange={(dict) => setCheckedValues({ ...checkedValues, ...dict })}
      />
      <ButtonsGroup
        buttons={[{ text: "INTEGRATE" }, { text: "CANCEL", onClick: onClose }]}
      />
    </ModalBox>
  );
};
